<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium">Модель</label>
            <crm-input-text
              [(value)]="kkt.model"
              [isError]="$any(errors?.model)"></crm-input-text>
            <small
              *ngIf="errors?.model"
              class="p-error">
              {{ errors.model | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Адрес регистрации</label>
            <crm-input-text
              [(value)]="kkt.address"
              [isError]="$any(errors?.address)"
              class="w-full"></crm-input-text>
            <small
              *ngIf="errors?.address"
              class="p-error">
              {{ errors.address | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Номер ФН</label>
            <crm-input-text
              [(value)]="kkt.fnNumber"
              [isError]="$any(errors?.fnNumber)"></crm-input-text>
            <small
              *ngIf="errors?.fnNumber"
              class="p-error">
              {{ errors.fnNumber | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">РНМ</label>
            <crm-input-text
              [(value)]="kkt.regNumber"
              [isError]="$any(errors?.regNumber)"></crm-input-text>
            <small
              *ngIf="errors?.regNumber"
              class="p-error">
              {{ errors.regNumber | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Заводской номер</label>
            <crm-input-text
              [(value)]="kkt.serialNumber"
              [isError]="$any(errors?.serialNumber)"></crm-input-text>
            <small
              *ngIf="errors?.serialNumber"
              class="p-error">
              {{ errors.serialNumber | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="kkt.contragent"
              [customSearch]="false"
              [isError]="$any(errors?.contragent)"
              [showClear]="true"
              appendTo="body"></crm-contragent-auto-complete>
            <small
              *ngIf="errors?.contragent"
              class="p-error">
              {{ errors.contragent | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Оператор ОФД</label>
            <crm-operator-single-select
              [(selectedOperator)]="operator"
              [isError]="$any(errors?.operator)"
              appendTo="body"></crm-operator-single-select>
            <small
              *ngIf="errors?.operator"
              class="p-error">
              {{ errors.operator | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  @if (fdoAccessService.fdoRights.canWriteKKT) {
    <div class="mt-3">
      <div class="flex flex-wrap justify-content-between">
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success"
          (onClick)="saveKkt()"></crm-button>

        @if ((form$ | async)?.isEdit) {
          <crm-button
            label="Удалить"
            styleClass="p-button-danger p-button-text"
            (onClick)="deleteKkt()"></crm-button>
        }
      </div>
    </div>
  }
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
